import React from 'react';
import { withRouter } from 'react-router-dom';

class EditarMovimentacao extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centro: "",
            centroId: 0,
            id: 0,
            contas: [],
            conta: "",
            contaNome: "",
            codigoConta: "",
            codigo: "",
            edConta: "",
            edCodigoConta: "",
            edCodigo: "",
            bancos: [],
            banco: "",
            historico: "",
            descricao: "",
            data: "",
            valor: "0,00",
            ghg: false,
            notaFiscal: null,
            comprovante: null,
            edNotaFiscal: null,
            edComprovante: null,
            analiseContabil: "",
            conf: false,
            filtroAno: "",
            filtroMes: "",
            vecMovPrev: null,
            vecMov: null
        };

        this.changeData = this.changeData.bind(this);
        this.changeBanco = this.changeBanco.bind(this);
        this.changeConta = this.changeConta.bind(this);
        this.changeHistorico = this.changeHistorico.bind(this);
        this.changeDescricao = this.changeDescricao.bind(this);
        this.changeValor = this.changeValor.bind(this);
        this.changeGhg = this.changeGhg.bind(this);
        this.changeNotaFiscal = this.changeNotaFiscal.bind(this);
        this.changeNotaFiscal = this.changeNotaFiscal.bind(this);
        this.changeComprovante = this.changeComprovante.bind(this);
        this.changeAnaliseContabil = this.changeAnaliseContabil.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    moneyMask(str_val) {

        let res = "";
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    moneyUnmask(str_val) {

        let res = "";
        let vec = str_val.split(",");

        for (let i = 0; i < vec[0].length; i++) {

            if (vec[0][i] !== ".") {
                res = res + vec[0][i];
            }

        }

        res = res + "." + vec[1];
        return res;

    }

    desformatarValor(s) {
        if (s === null) return "";
        return this.moneyUnmask(s);
    }

    formatarValor(s) {
        if (s === null) return "";
        return this.moneyMask(s);
    }

    changeData(e) {

        let i = e.target.value;

        if (i !== "" && this.state.conta !== "") {

            let vec = i.split("-");
            this.setState({ data: i });

            if (this.state.edConta !== "") {
                this.setState({ edCodigo: this.state.edCodigoConta + "-" + vec[1] });
            } else {
                this.setState({ edCodigo: this.state.codigoConta + "-" + vec[1] });
            }

        } else if (i !== "" && this.state.conta === "") {

            this.setState({ data: i });
            this.setState({ edCodigo: "" });

        } else {

            this.setState({ data: i });
            this.setState({ edCodigo: "" });

        }

    }

    changeBanco(e) {
        this.setState({ banco: e.target.value });
    }

    changeConta(e) {

        let i = e.target.value;

        if (i !== "" && this.state.data !== "") {

            let vec = this.state.data.split("-");
            this.setState({ edConta: i });
            this.setState({ edCodigoConta: this.state.contas[i].cod_conta });
            this.setState({ edCodigo: this.state.contas[i].cod_conta + "-" + vec[1] });

        } else if (i !== "" && this.state.data === "") {

            this.setState({ edConta: i });
            this.setState({ edCodigoConta: this.state.contas[i].cod_conta });
            this.setState({ edCodigo: "" });

        } else {

            this.setState({ edConta: "" });
            this.setState({ edCodigoConta: "" });
            this.setState({ edCodigo: "" });

        }

    }

    changeHistorico(e) {
        this.setState({ historico: e.target.value });
    }

    changeDescricao(e) {
        this.setState({ descricao: e.target.value });
    }

    changeValor(e) {

        let sval = "";
        let re = /^(-|[0-9])$/i;
        let neg = false;

        if (e.target.value !== "-0,0") {

            for (let i = 0; i < e.target.value.length; i++) {

                if (re.test(e.target.value[i])) {

                    if (e.target.value[i] === "-") neg = true;
                    else sval = sval + e.target.value[i];

                }

            }

        }

        sval = parseInt(sval);
        sval = sval.toString();
        let res = "";

        if (sval === "NaN") {

            res = "0,00";

        } else if (sval.length === 1) {

            res = "0,0" + sval;

        } else if (sval.length === 2) {

            res = "0," + sval;

        } else {

            let i = sval.length - 1;
            let c = 0;

            res = sval[i] + res;
            i--;

            res = sval[i] + res;
            i--;

            res = "," + res;

            for (; i >= 0; i--) {

                if (c !== 0 && c % 3 === 0) {
                    res = sval[i] + "." + res;
                } else {
                    res = sval[i] + res;
                }

                c++;

            }

        }

        if (neg) {
            res = "-" + res;
        }

        this.setState({ valor: res });

    }

    changeGhg(e) {
        if (e.target.value === "true") this.setState({ ghg: true });
        else this.setState({ ghg: false });
    }

    changeNotaFiscal(e) {
        e.preventDefault();
        this.setState({ edNotaFiscal: e.target.files[0] });
    }

    changeComprovante(e) {
        e.preventDefault();
        this.setState({ edComprovante: e.target.files[0] });
    }

    changeAnaliseContabil(e) {
        this.setState({ analiseContabil: e.target.value });
    }

    cadastrar() {

        this.setState({ disabled: true });

        let re = /^.{1,}\.(pdf|xml|jpg|jpeg|png)$/i;

        if (this.state.data === "") {

            this.props.errMsgHandler("Por favor, informe a data da movimentação financeira.");
            this.setState({ disabled: false });

        } else if (this.state.banco === "") {

            this.props.errMsgHandler("Por favor, informe o banco.");
            this.setState({ disabled: false });

        } else if (this.state.conta === "") {

            this.props.errMsgHandler("Por favor, informe a conta da movimentação financeira.");
            this.setState({ disabled: false });

        } else if (this.state.historico === "") {

            this.props.errMsgHandler("Por favor, informe o histórico.");
            this.setState({ disabled: false });

        } else if (this.state.descricao === "") {

            this.props.errMsgHandler("Por favor, informe a descrição da movimentação financeira.");
            this.setState({ disabled: false });

        } else if (this.state.valor === "") {

            this.props.errMsgHandler("Por favor, informe o valor da movimentação financeira.");
            this.setState({ disabled: false });

        } else if (this.state.edNotaFiscal !== null && !re.test(this.state.edNotaFiscal.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");
            this.setState({ disabled: false });

        } else if (this.state.edComprovante !== null && !re.test(this.state.edComprovante.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");
            this.setState({ disabled: false });

        } else if (this.state.analiseContabil === "") {

            this.props.errMsgHandler("Por favor, informe a análise contábil.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                id: this.state.id,
                banco: this.state.banco,
                data: this.state.data,
                historico: this.state.historico,
                descricao: this.state.descricao,
                valor: this.desformatarValor(this.state.valor),
                ghg: this.state.ghg,
                status: 0,
                nota_fiscal: this.state.notaFiscal,
                comprovante: this.state.comprovante,
                analise_contabil: this.state.analiseContabil,
                conta_id: this.state.conta
            };

            if (this.state.edConta !== "") {
                obj.conta_id = this.state.contas[this.state.edConta].id;
            }

            let formData1 = new FormData();
            let formData2 = new FormData();

            if (this.state.edNotaFiscal !== null) {
                obj.nota_fiscal = this.state.edNotaFiscal.name;
                formData1.append('file', this.state.edNotaFiscal);
            }

            if (this.state.edComprovante !== null) {
                obj.comprovante = this.state.edComprovante.name;
                formData2.append('file', this.state.edComprovante);
            }

            fetch("/api/movimentacao/editar", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    if (this.state.edNotaFiscal === null && this.state.edComprovante === null) {

                        this.props.waitMsgHandler("");
                        this.props.successMsgHandler("Movimentação financeira editada com sucesso.");

                        let obj2 = {
                            row: {
                                id: this.state.id,
                                data: [],
                            },
                            filtroAno: this.state.filtroAno,
                            filtroMes: this.state.filtroMes,
                            vecMovPrev: this.state.vecMovPrev,
                            vecMov: this.state.vecMov
                        };

                        this.props.history.push({
                            pathname: "/visualizarmovimentacao",
                            state: obj2
                        });

                    } else if (this.state.edNotaFiscal !== null && this.state.edComprovante === null) {

                        fetch("/api/movimentacao/upload/nf/" + this.state.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData1
                        })
                        .then(response2 => response2.json())
                        .then(responseJson2 => {

                            if (responseJson2.msg === "success") {

                                this.props.waitMsgHandler("");
                                this.props.successMsgHandler("Movimentação financeira editada com sucesso.");

                                let obj2 = {
                                    row: {
                                        id: this.state.id,
                                        data: [],
                                    },
                                    filtroAno: this.state.filtroAno,
                                    filtroMes: this.state.filtroMes,
                                    vecMovPrev: this.state.vecMovPrev,
                                    vecMov: this.state.vecMov
                                };

                                this.props.history.push({
                                    pathname: "/visualizarmovimentacao",
                                    state: obj2
                                });

                            }

                        });

                    } else if (this.state.edNotaFiscal === null && this.state.edComprovante !== null) {

                        fetch("/api/movimentacao/upload/cp/" + this.state.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData2
                        })
                        .then(response2 => response2.json())
                        .then(responseJson2 => {

                            if (responseJson2.msg === "success") {

                                this.props.waitMsgHandler("");
                                this.props.successMsgHandler("Movimentação financeira editada com sucesso.");

                                let obj2 = {
                                    row: {
                                        id: this.state.id,
                                        data: [],
                                    },
                                    filtroAno: this.state.filtroAno,
                                    filtroMes: this.state.filtroMes,
                                    vecMovPrev: this.state.vecMovPrev,
                                    vecMov: this.state.vecMov
                                };

                                this.props.history.push({
                                    pathname: "/visualizarmovimentacao",
                                    state: obj2
                                });

                            }

                        });

                    } else {

                        fetch("/api/movimentacao/upload/nf/" + this.state.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData1
                        })
                        .then(response2 => response2.json())
                        .then(responseJson2 => {

                            if (responseJson2.msg === "success") {

                                fetch("/api/movimentacao/upload/cp/" + this.state.id, {
                                    method: "POST",
                                    headers: {
                                        "Authorization": "Basic " + btoa(localStorage.auth)
                                    },
                                    mode: "cors",
                                    body: formData2
                                })
                                .then(response3 => response3.json())
                                .then(responseJson3 => {

                                    if (responseJson3.msg === "success") {

                                        this.props.waitMsgHandler("");
                                        this.props.successMsgHandler("Movimentação financeira editada com sucesso.");

                                        let obj2 = {
                                            row: {
                                                id: this.state.id,
                                                data: [],
                                            },
                                            filtroAno: this.state.filtroAno,
                                            filtroMes: this.state.filtroMes,
                                            vecMovPrev: this.state.vecMovPrev,
                                            vecMov: this.state.vecMov
                                        };

                                        this.props.history.push({
                                            pathname: "/visualizarmovimentacao",
                                            state: obj2
                                        });

                                    }

                                });

                            }

                        });

                    }

                }

            });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: []
            },
            filtroAno: this.state.filtroAno,
            filtroMes: this.state.filtroMes,
            vecMovPrev: this.state.vecMovPrev,
            vecMov: this.state.vecMov
        };

        this.props.history.push({
            pathname: "/visualizarmovimentacao",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes !== "escrever"
            && localStorage.roleMovimentacoes !== "corrigir") {

            window.location.href = "/home";

        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoescentro";
        }

        let centro = this.props.location.state.centro;
        let centroId = this.props.location.state.centroId;
        let id = this.props.location.state.id;
        let banco = this.props.location.state.banco;
        let data = this.props.location.state.data;
        let historico = this.props.location.state.historico;
        let descricao = this.props.location.state.descricao;
        let valor = this.props.location.state.valor;
        let notaFiscal = this.props.location.state.notaFiscal;
        let comprovante = this.props.location.state.comprovante;
        let analiseContabil = this.props.location.state.analiseContabil;
        let ghg = this.props.location.state.ghg;
        let conta = this.props.location.state.conta;
        let contaNome = this.props.location.state.contaNome;
        let codigoConta = this.props.location.state.codConta;
        let codigo = this.props.location.state.codMovimentacao;
        let filtroAno = this.props.location.state.filtroAno;
        let filtroMes = this.props.location.state.filtroMes;
        let vecMovPrev = this.props.location.state.vecMovPrev;
        let vecMov = this.props.location.state.vecMov;

        this.setState({ centro: centro });
        this.setState({ centroId: centroId });
        this.setState({ id: id });
        this.setState({ banco: banco });
        this.setState({ data: data });
        this.setState({ historico: historico });
        this.setState({ descricao: descricao });
        this.setState({ valor: this.formatarValor(valor) });
        this.setState({ notaFiscal: notaFiscal });
        this.setState({ comprovante: comprovante });
        this.setState({ analiseContabil: analiseContabil });
        this.setState({ conta: conta });
        this.setState({ contaNome: contaNome });
        this.setState({ codigoConta: codigoConta });
        this.setState({ codigo: codigo });
        this.setState({ filtroAno: filtroAno });
        this.setState({ filtroMes: filtroMes });
        this.setState({ vecMovPrev: vecMovPrev });
        this.setState({ vecMov: vecMov });

        if (ghg === 0) {
            this.setState({ ghg: false });
        } else {
            this.setState({ ghg: true });
        }

        fetch("/api/centro/banco/" + centroId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ bancos: responseJson });

            fetch("/api/conta/centro/" + centroId, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ contas: responseJson2 });

            });

        });

    }

    render() {
        return(
            <div>
                <h1 id="editarmov-title">
                    Editar Movimentação Financeira
                </h1><br />
                <p id="editarmov-centro">
                    <b>Centro:</b> { this.state.centro }
                </p><br />
                <p id="editarmov-obrigatorios">* Campos obrigatórios.</p><br /><br />
                <form id="editarmov-form">
                    <ul class="editarmov-ghg-lst">
                        <li>
                            <b>GHG: </b>
                            <label>
                                <input type="radio"
                                    name="ghg"
                                    value="true"
                                    checked={ this.state.ghg === true }
                                    onChange={ this.changeGhg } /> Sim
                            </label>
                            <label>
                                <input type="radio"
                                    name="ghg"
                                    value="false"
                                    checked={ this.state.ghg === false }
                                    onChange={ this.changeGhg } /> Não
                            </label>
                        </li>
                    </ul><br /><br />
                    <span id="editarmov-data-span"><b>Data*: </b></span>
                    <input type="date"
                        value={ this.state.data }
                        onChange={ this.changeData } /><br />
                    <select id="editarmov-banco-select"
                        value={ this.state.banco }
                        onChange={ this.changeBanco }>
                        <option value="">Banco*</option>
                        { this.state.bancos.map((item, i) =>
                            <option key={ i } value={ i }>{ item }</option> ) }
                    </select><br /><br />
                    <span id="editarmov-nf-span">
                        <b>Conta (atual): </b>{ this.state.contaNome  }
                    </span><br /><br />
                    <span id="editarmov-nf-span">
                        <b>Código da Conta (atual): </b>{ this.state.codigoConta }
                    </span><br /><br />
                    <span id="editarmov-nf-span">
                        <b>Código da Movimentação (atual): </b>{ this.state.codigo  }
                    </span><br /><br />
                    <select value={ this.state.edConta } onChange={ this.changeConta }>
                        <option value="">Conta</option>
                        { this.state.contas.map((item, i) =>
                            <option key={ i } value={ i }>{ item.cod_conta + " - " + item.conta }</option> ) }
                    </select><br />
                    <input type="text"
                        placeholder="Código da Conta"
                        value={ this.state.edCodigoConta }
                        disabled /><br />
                    <input type="text"
                        placeholder="Código da Movimentação"
                        value={ this.state.edCodigo }
                        disabled /><br /><br />
                    <input type="text"
                        placeholder="Histórico*"
                        value={ this.state.historico }
                        onChange={ this.changeHistorico } /><br />
                    <textarea placeholder="Descrição da Movimentação*"
                        value={ this.state.descricao }
                        onChange={ this.changeDescricao }></textarea><br />
                    <span Class="cadmovimentacao-somente-numeros">
                        (Somente valores númericos no campo de Valor. Ex: 10, 1.5, ...)
                    </span><br /><br />
                    <span Class="cadmovimentacao-somente-numeros">
                        (Utilize vírgula (,) para separar a parte inteira da parte decimal.)
                    </span><br /><br />
                    <input type="text"
                        placeholder="Valor (R$)*"
                        value={ this.state.valor }
                        onChange={ this.changeValor } /><br />
                    <span id="editarmov-nf-span">
                        <b>Documento fiscal*: </b>
                        { this.state.notaFiscal  }
                    </span><br /><br />
                    <input type="file"
                        id="editarmov-nf-file"
                        onChange={ this.changeNotaFiscal }
                        accept="application/pdf, image/jpeg, image/png, application/xml" />
                    <br /><br /><br />
                    <span id="editarmov-nf-span">
                        <b>Comprovante de pagamento*: </b>
                        { this.state.comprovante }
                    </span><br /><br />
                    <input type="file"
                        id="editarmov-nf-file"
                        onChange={ this.changeComprovante }
                        accept="application/pdf, image/jpeg, image/png, application/xml" />
                    <br /><br /><br />
                    <textarea placeholder="Análise Contábil*"
                        value={ this.state.analiseContabil }
                        onChange={ this.changeAnaliseContabil }></textarea><br /><br /><br />
                    <button type="button"
                        id="editarmov-salvar-btn"
                        onClick={ this.cadastrar }
                        disabled={ this.state.disabled }>
                        Salvar
                    </button>
                    <button type="button" id="editarmov-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default withRouter(EditarMovimentacao);

